import { useState } from "react";
import { Clock, CalendarX2 } from "lucide-react";
import WeeklyAvailability from "@/pages/scheduling/WeeklyAvailability";
import DateOverridesTab from "@/pages/scheduling/DateOverridesTab";

/**
 * Merged Availability container.
 *
 * Weekly Hours = recurring availability. Date Overrides = exceptions (holidays,
 * time-off, or ad-hoc custom hours) that override Weekly Hours for specific
 * dates. Both live under one card because Overrides only make sense in the
 * context of the underlying Weekly schedule.
 */
export default function AvailabilityTab() {
  const [sub, setSub] = useState("weekly");
  const TABS = [
    { key: "weekly", label: "Weekly Hours", icon: Clock, testid: "availability-sub-weekly" },
    { key: "overrides", label: "Date Overrides", icon: CalendarX2, testid: "availability-sub-overrides" },
  ];
  return (
    <div className="space-y-4" data-testid="availability-tab">
      <div>
        <h2 className="font-display font-semibold text-lg tracking-tight">Availability</h2>
        <p className="text-xs text-[#57534E] mt-0.5">
          Set your regular working hours and make exceptions for specific dates.
        </p>
      </div>
      <div className="bg-white rounded-2xl border border-[#E8E2D9] p-1.5 inline-flex gap-1"
           data-testid="availability-subtabs">
        {TABS.map((t) => {
          const isOn = sub === t.key;
          const Icon = t.icon;
          return (
            <button key={t.key} data-testid={t.testid} onClick={() => setSub(t.key)}
              className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors ${
                isOn ? "bg-[#E8712C] text-white" : "text-[#57534E] hover:text-[#1C1917]"
              }`}>
              <Icon size={13} strokeWidth={1.75} /> {t.label}
            </button>
          );
        })}
      </div>
      {sub === "weekly" ? <WeeklyAvailability /> : <DateOverridesTab />}
    </div>
  );
}
